/**
 * @generated SignedSource<<e880ea954d029e72aaf0b256ac37aa95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TimeOnPlatformCreateMutation$variables = Record<PropertyKey, never>;
export type TimeOnPlatformCreateMutation$data = {
  readonly createUserPlatformSession: {
    readonly userPlatformSessionNode: {
      readonly id: string;
    } | null | undefined;
  };
};
export type TimeOnPlatformCreateMutation = {
  response: TimeOnPlatformCreateMutation$data;
  variables: TimeOnPlatformCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CreateUserPlatformSessionPayload",
    "kind": "LinkedField",
    "name": "createUserPlatformSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserPlatformSessionNode",
        "kind": "LinkedField",
        "name": "userPlatformSessionNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeOnPlatformCreateMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TimeOnPlatformCreateMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e5b3045d36f3f9b16d29c51c0bf5eaa4",
    "id": null,
    "metadata": {},
    "name": "TimeOnPlatformCreateMutation",
    "operationKind": "mutation",
    "text": "mutation TimeOnPlatformCreateMutation {\n  createUserPlatformSession {\n    userPlatformSessionNode {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff219df6723050550a409a4cf97dbd6d";

export default node;
